export default {
    UX_INIT: function(state, data) {
        state.ux = data
    }
}